export const TEAL = '#00ACA0';
export const TEAL_300 = '#4DB6AC';
export const TEAL_200 = '#80CBC4';
export const TEAL_100 = '#B2DFDB';
export const TEAL_50 = '#E0F2F1';

export const PURPLE = '#7E57C2';
export const PURPLE_300 = '#9575CD';
export const PURPLE_200 = '#B39DDB';
export const PURPLE_100 = '#D1C4E9';
export const PURPLE_50 = '#EDE7F6';

export const BLACK = '#000000';
export const BLACK_200 = '#C1C6C9';
export const BLACK_400 = '#899296';
export const BLACK_500 = '#3D3F40';
export const GREY = '#212121';
export const GREY_900 = '#212121';
export const GREY_700 = '#616161';
export const GREY_600 = '#757575';
export const GREY_500 = '#9E9E9E';
export const GREY_400 = '#BDBDBD';
export const GREY_300 = '#E0E0E0';
export const GREY_100 = '#F5F5F5';
export const GREY_200 = '#F0F0F0';
export const GREY_50 = '#FAFAFA';
export const WHITE = '#FFFFFF';

export const BLUE = '#276EF1';
export const BLUE_300 = '#5A90F4';
export const BLUE_200 = '#9FBFF8';
export const BLUE_100 = '#D4E2FC';
export const BLUE_50 = '#EDF3FD';

export const GREEN = '#00AD50';
export const GREEN_300 = '#43BF75';
export const GREEN_200 = '#9EE2B8';
export const GREEN_100 = '#CFF3DD';
export const GREEN_50 = '#F0FAF3';
export const GREEN_500 = '#52bf00';

export const RED = '#F44336';
export const RED_300 = '#E57373';
export const RED_200 = '#EF9A9A';
export const RED_100 = '#FFCDD2';
export const RED_50 = '#FFEBEE';
export const RED_400 = '#EE4040';

export const BROWN = '#653818';
export const BROWN_300 = '#B18976';
export const BROWN_200 = '#D2BAB0';
export const BROWN_100 = '#EBE0DB';
export const BROWN_50 = '#F6F2F0';

export const ORANGE = '#FF6A39';
export const ORANGE_300 = '#F19063';
export const ORANGE_200 = '#F7BFA5';
export const ORANGE_100 = '#FBE2D6';
export const ORANGE_50 = '#FDF3EE';
export const ORANGE_400 = '#ff900d';

export const YELLOW = '#FFB822';
export const YELLOW_300 = '#FFCF70';
export const YELLOW_200 = '#FFE3AC';
export const YELLOW_100 = '#FFF2D9';
export const YELLOW_50 = '#FFF9EF';

export const PINK = '#CC0066';
export const PINK_300 = '#F06292';
export const PINK_200 = '#F48FB1';
export const PINK_100 = '#F8BBD0';
export const PINK_50 = '#FCE4EC';
export const PINK_350 = '#FE0557';

export const GRAY = '#899296';
export const GRAY_DARK = '#3d3f40';
export const GRAY_SOLID = '#DEE2EA';

export const PRIMARY_LIGHT = '#f5cce0';

export const PRIMARY = PINK;
export const SECONDARY = BLUE;
